import type { Column } from '@tanstack/react-table'
import * as React from 'react'
import { ArrowDown, ArrowUp, ChevronsUpDown } from 'lucide-react'

import cn from '@config/tailwind/cn'

import { Button } from './button'

interface DataTableColumnHeaderProps<TData, TValue> extends React.HTMLAttributes<HTMLDivElement> {
  column: Column<TData, TValue>
  title?: string
}

export function DataTableColumnHeader<TData, TValue>({
  column,
  title,
  className,
}: DataTableColumnHeaderProps<TData, TValue>) {
  if (!column.getCanSort()) {
    return <div className={cn(className)}>{title ?? column.id}</div>
  }

  return (
    <div className={cn('ui:flex ui:items-center ui:space-x-2', className)}>
      <Button baseButton variant='ghost' size='sm' className='ui:-ml-3 ui:h-8' onClick={() => column.toggleSorting()}>
        <span className='ui:text-complementary-black'>{title ?? column.id}</span>
        {column.getIsSorted() === 'desc' ? (
          <ArrowDown className='ui:ml-1 ui:size-4 ui:text-main-blue-100' />
        ) : column.getIsSorted() === 'asc' ? (
          <ArrowUp className='ui:ml-1 ui:size-4 ui:text-main-blue-100' />
        ) : (
          <ChevronsUpDown className='ui:ml-1 ui:size-4 ui:text-main-blue-100' />
        )}
      </Button>
    </div>
  )
}
